import { Auth } from 'aws-amplify'

let onMessageMap = new Map() // Stores accountNumbers and their components' callbacks
let socketNotify = null

export const SocketNotifyMixin = {
  data() {
    return {
      subscribedAccountNumbers: [], // Store accountNumbers this component has subscribed to
    }
  },
  methods: {
    async connectToSocketNotify() {
      if (socketNotify) {
        return
      }
      const io = require('socket.io-client')
      const session = await Auth.currentSession()
      const token = session.getIdToken().getJwtToken()

      const socketUrl =
        process.env.VUE_APP_SOCKET_NOTIFY_URL || 'http://localhost:9000'

      socketNotify = io(socketUrl, {
        path: process.env.VUE_APP_SOCKET_NOTIFY_PATH || '',
        auth: { token },
      })
      socketNotify.on('connect', () => {
        console.log('Socket Notify Connected', socketNotify)
        this.resubscribeAccountNumbers()
      })
      socketNotify.on('message', (msg) => {
        if (msg && msg.account_number && onMessageMap.has(msg.account_number)) {
          onMessageMap.get(msg.account_number).forEach(({ callback }) => {
            try {
              callback(msg)
            } catch (e) {
              console.log(e)
            }
          })
        }
      })
    },
    resubscribeAccountNumbers() {
      const accountNumbers = Array.from(onMessageMap.keys())
      if (accountNumbers.length && socketNotify) {
        socketNotify.emit('subscribe', accountNumbers)
      }
    },
    subscribeAccountNumber(accountNumbers, componentId, onMessage) {
      let newAccountNumbers = []
      for (let accountNumber of accountNumbers) {
        if (!onMessageMap.has(accountNumber)) {
          onMessageMap.set(accountNumber, [])
          newAccountNumbers.push(accountNumber)
        }

        if (
          !onMessageMap
            .get(accountNumber)
            .some((entry) => entry.componentId === componentId)
        ) {
          onMessageMap
            .get(accountNumber)
            .push({ componentId, callback: onMessage })
        }
      }

      if (newAccountNumbers.length && socketNotify) {
        socketNotify.emit('subscribe', newAccountNumbers)
      }
    },
    unsubscribeAccountNumber(accountNumbers, componentId) {
      let toUnsubscribe = []

      for (let accountNumber of accountNumbers) {
        if (onMessageMap.has(accountNumber)) {
          onMessageMap.set(
            accountNumber,
            onMessageMap.get(accountNumber).filter((entry) => {
              const componentIdToCheck = entry.componentId || ''
              return !componentIdToCheck.toString().includes(componentId)
            })
          )

          if (onMessageMap.get(accountNumber).length === 0) {
            onMessageMap.delete(accountNumber)
            toUnsubscribe.push(accountNumber)
          }
        }
      }

      if (toUnsubscribe.length && socketNotify) {
        socketNotify.emit('unsubscribe', toUnsubscribe)
      }
    },
    closeWSNotify() {
      if (socketNotify) {
        socketNotify.close()
        socketNotify = null
      }
    },
  },
  beforeDestroy() {
    // debugger
    // this.closeWSNotify()
    this.unsubscribeAccountNumber(this.subscribedAccountNumbers, this._uid)
  },
}
